<div class="d-flex border-bottom">
	<div class="col-sm-10">
		<h3 class="mat-dialog-title arc-h3 margin-top-20" id="note-dialog">{{ dialogTitle?.toLocaleUpperCase() }}</h3>
	</div>
	<div class="col-sm-2 text-right">
		<app-close-mat-dialog (closeDialog)="dialog.closeAll()"></app-close-mat-dialog>
	</div>
</div>

<div mat-dialog-content class="blue-bg">
	<div [style.padding-top]="'5px'" class="border-bottom p-3" *ngIf="!readOnly || data.isLegalRoleHolder">
		<div class="row margin-top-10">
			<div class="col-sm-6">
				<h4 class="arc-h4">Add Notes</h4>
			</div>
			<div class="col-sm-6 text-right">
				<button type="button" mat-button appDebounceClick color="primary" (debounceClick)="clearForm()"
					id="new-note-clear-button" class="mat-button-md">
					Cancel
				</button>
				<button type="submit" mat-flat-button color="primary" [disabled]="noteForm.invalid || noteForm.disabled"
					class="mat-button-md margin-left-20" appDebounceClick
					(debounceClick)="isHearing? (isNoteSelected? onHearingNoteEdit(): saveHearingNote()): saveNote()"
					id="new-note-save-button" appSaveHotkey (onSaveHotkey)="saveNote()"
					[isDisabled]="noteForm.invalid || noteForm.disabled">
					{{ isNoteSelected ? 'Update' : 'Add' }}
				</button>
			</div>
		</div>
		<form [formGroup]="noteForm" (ngSubmit)="saveNote()">
			<div class="row d-flex align-items-center" id="editForm">
				<div class="col-sm-5 margin-top-20">
					<mat-form-field class="input-full-width" appearance="outline">
						<mat-label>Subject</mat-label>
						<input type="text" placeholder="Subject" aria-label="Subject" matInput
							(ngModelChange)="onSubjectChanges($event)" formControlName="subject"
							[matAutocomplete]="auto" [maxLength]="70" id="subject-input"
							[readonly]="isSubjectOptionsDisabled" />
						<mat-autocomplete #auto="matAutocomplete">
							<ng-container *ngIf="!isAdr && !isSystemicModuleRoute && !isSubjectOptionsDisabled">
								<ng-container *ngFor="let item of subjectOptions">
									<mat-option [value]="item.display" *ngIf="!isChargeParticularsSubject(item.display)"
										[disabled]="item.isLegalComplaintFiling">
										{{ item?.display?.toUpperCase() }}
									</mat-option>
								</ng-container>
							</ng-container>
							<mat-option *ngIf="isAdr && !isSystemicModuleRoute" [value]="adrOption.value">
								{{ adrOption?.display?.toUpperCase() }}
							</mat-option>
						</mat-autocomplete>
						<mat-error *ngIf="noteForm.get('subject').invalid && noteForm.get('subject').touched">
							You must select a subject
						</mat-error>
					</mat-form-field>
				</div>
				<div *ngIf="!isSystemicModuleRoute && !isLitigation" class="col-sm-4">
					<mat-checkbox matSuffix formControlName="isNonDisclosable" id="isNonDisclosable">
						Non-Disclosable under FOIA
					</mat-checkbox>
				</div>
			</div>

			<div *ngIf="!isSystemicModuleRoute" class="note-textarea">
				<mat-form-field class="input-full-width" appearance="outline">
					<mat-label>Note</mat-label>
					<textarea matInput cdkTextareaAutosize [maxLength]=maxLength cdkAutosizeMinRows="3"
						cdkAutosizeMaxRows="3" spellcheck="true" placeholder="Enter notes..." formControlName="note"
						id="note-input" required></textarea>
					<mat-error *ngIf="noteForm.get('note').invalid && noteForm.get('note').touched">
						You must enter a note
					</mat-error>
				</mat-form-field>
				<div class="text-right text-area-count">{{ noteForm.get('note').value?.length || 0 }} / {{maxLength}}
				</div>
			</div>
			<div *ngIf="isSystemicModuleRoute" class="note-textarea">
				<mat-form-field class="input-full-width" appearance="outline">
					<mat-label>Note</mat-label>
					<textarea matInput cdkTextareaAutosize [maxLength]="5000" cdkAutosizeMinRows="3"
						cdkAutosizeMaxRows="3" spellcheck="true" placeholder="Enter notes..." formControlName="note"
						id="systemic-note-input" required></textarea>
					<mat-error *ngIf="noteForm.get('note').invalid && noteForm.get('note').touched">
						You must enter a note
					</mat-error>
				</mat-form-field>
				<div class="text-right text-area-count">{{ noteForm.get('note').value?.length || 0 }} / 5000</div>
			</div>
		</form>
	</div>
	<mat-card appearance="outlined" class="border-bottom padding-left-20 ">
		<div>
			<div *ngIf="notes?.length === 0" class="text-center">
				You have no notes. <span *ngIf="!readOnly">Please add one above.</span>
			</div>
			<div *ngIf="notes?.length > 0">
				<div>
					<div fxLayout="row wrap" fxLayoutAlign="space-between center">
						<div fxFlex="90">
							<div fxFlex="80" fxFlex.md="80" fxFlex.sm="100" fxFlex.xs="100">
								<mat-form-field class="input-full-width" appearance="outline">
									<mat-label>Search</mat-label>
									<input matInput id="filterNote" name="filterNote" [(ngModel)]="filter.note"
										(ngModelChange)="applyFilter()" />
								</mat-form-field>
							</div>
							<div fxFlex="20" fxFlex.md="20" fxFlex.sm="100" fxFlex.xs="100"
								*ngIf="!isAdr && !isSystemicModuleRoute" class="margin-left-20">
								<mat-form-field class="input-full-width" appearance="outline">
									<mat-label>Filter by Subject</mat-label>
									<mat-select [(ngModel)]="filter.subject" name="filterSubject"
										(ngModelChange)="applyFilter()" multiple id="fiterSubject" aria-label="Filter by Subject {{
											filter.subject
												? 'list box with ' + getNamesByValues(filter.subject, subjectOptions) + ' value selected'
												: ''
										}}">
										<mat-option *ngFor="let item of subjectOptions" [value]="item.display">
											{{ item.display }}
										</mat-option>
									</mat-select>
								</mat-form-field>
							</div>
						</div>
						<div *ngIf="!isLitigation" fxFlex="10" class="d-flex justify-content-end">
							<mat-icon matTooltip="Export" appAnnounceTooltip="Export" (debounceClick)="exportNotes()"
								class="icon-blue mr-5" appDebounceClick *ngIf="hasExportPermission"
								id="export-notes-btn">
								file_download
							</mat-icon>
						</div>
					</div>
				</div>
				<div role="status" class="sr-only" aria-live="polite">{{ ariaResultAlert }} results found</div>
				<table mat-table class="margin-top-buttom-20" (matSortChange)="onSort($event)" [dataSource]="notesData"
					matSort appAnnounceSortChange>
					<ng-container matColumnDef="icon">
						<th mat-header-cell *matHeaderCellDef></th>
						<td mat-cell *matCellDef="let row">
							<mat-icon
								*ngIf="(row?.isNonDisclosable && !isHearing || row?.isNonDisclosable === 'Y' && isHearing)"
								title="Confidential" class="condidential-icon" matTooltip="Confidential"
								appAnnounceTooltip="Confidential">
								privacy_tip
							</mat-icon>
						</td>
					</ng-container>
					<ng-container matColumnDef="createdBy">
						<th mat-header-cell *matHeaderCellDef mat-sort-header
							sortActionDescription="Sort by created by">
							<div>Created by</div>
						</th>
						<!-- This lead column is a th in order to read this column to the user when they are tabbing through the table -->
						<th mat-cell *matCellDef="let row" class="lead-col mat-mdc-cell">{{ row?.staffName }}</th>
					</ng-container>
					<ng-container matColumnDef="posted">
						<th mat-header-cell *matHeaderCellDef mat-sort-header
							sortActionDescription="Sort by posted date">
							<div>Posted</div>
						</th>
						<td mat-cell *matCellDef="let row">
							{{ cmnServ.displayEsttoLocale(row?.noteDate, false) }}
						</td>
					</ng-container>
					<ng-container matColumnDef="subject">
						<th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by subject">
							<div>Subject</div>
						</th>
						<td mat-cell *matCellDef="let row">
							{{ row?.subject }}
						</td>
					</ng-container>
					<ng-container matColumnDef="note">
						<th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by note">
							<div>Note</div>
						</th>
						<td mat-cell *matCellDef="let row" class="break-word padding-right-10">
							<div [innerHTML]="row?.note"></div>
						</td>
					</ng-container>
					<ng-container matColumnDef="options">
						<th mat-header-cell *matHeaderCellDef>Actions</th>
						<td mat-cell *matCellDef="let row; let idx = index">
							<ng-container
								*ngIf="((userdetailId == row.staffId && !isChargeParticularsSubject(row?.subject)) || hasEditPermission || (isHearing && !readOnly))">
								<button mat-icon-button class="icon-blue" matTooltip="Edit" appAnnounceTooltip="Edit"
									appDebounceClick
									*ngIf="(!row?.subject.includes('Legal Disposition') && !data?.isLitigation) || isHearing"
									(debounceClick)="onEdit(row)"
									id="edit-row-btn-{{ idx }}"><mat-icon>edit</mat-icon></button>
								<button mat-icon-button class="icon-red" matTooltip="Delete" appAnnounceTooltip="Delete"
									*ngIf="(!isCaseComplaintFilingSubject(row?.subject) || !(data.isLitigation &&  data.isLegalRoleHolder)) || isHearing"
									appDebounceClick (debounceClick)="onDelete(row)"
									id="delete-row-btn-{{ idx }}"><mat-icon>delete</mat-icon></button>
							</ng-container>
						</td>
					</ng-container>
					<tr mat-header-row *matHeaderRowDef="displayColumns"></tr>
					<tr class="mat-table-row" mat-row *matRowDef="let row; columns: displayColumns"></tr>
				</table>

				<div *ngIf="notes?.length > 0 && notesData?.length == 0" class="text-center">No matched records found.
				</div>
				<mat-paginator (page)="onPage($event)" [length]="notes?.length" [pageSize]="perPage"
					[pageSizeOptions]="pageSizeOptions"></mat-paginator>
			</div>
		</div>
	</mat-card>
</div>